/**
 * 图片着色,不能转换黑色,可以将白色图片转换为其他任意颜色
 * 
 */

/**
 * 
 * @param {*白色底图} baseUrl 
 * @param {*} ops 
 */
export function ImageColour(baseUrl, ops) {
    //配置选项
    ops = ops || {};
    ops = {
        width: ops.width || 64,
        height: ops.height || 64
    }
    //初始化画布
    let canvas = document.createElement('canvas');
    canvas.width = ops.width;
    canvas.height = ops.height;
    let cxt = canvas.getContext('2d');
    cxt.willReadFrequently = true;
    //初始化底图（必须为白色）
    let baseImg = new Image();
    baseImg.src = baseUrl;
    this.canvas = canvas;
    this.cxt = cxt;
    this.baseImg = baseImg;
    this.inited = false;
    let self = this;
    baseImg.onload = function () {
        self.inited = true;
        for (var i = 0; i < self.waitList.length; i++) {
            self.waitList[i]();
        }
    }
    //初始化等待执行的列表
    self.waitList = [];
    //已经存在的列表
    self.imgList = [];
}

//转换
ImageColour.prototype.convert = function (rgb, seq, fontRgb, callback) {
    if (this.inited) {
        rgb=colorRgb(rgb);
        let item = self.find((s) => s.rgb == rgb);
        if (!item) {
            let lightness = 1;
            let width = this.canvas.width;
            let height = this.canvas.height;
            //先获取用来混合计算的原始数据（也就是白色底图）     
            
            // 白色底, 除了颗粒图外，其他都为白色，透明度为0.1, 确保一定的阴影
            this.cxt.fillStyle = 'rgba(255, 255, 255, 0.1)'                 //白色底，白底
            this.cxt.clearRect(0, 0, width, height);
            this.cxt.fillRect(0, 0, width, height);
            
            this.cxt.drawImage(this.baseImg, 0, 0, width, height);
            var whiteData = this.cxt.getImageData(0, 0, width, height)
            //混合计算
            for (var i = 0; i < whiteData.data.length; i += 4) {
                var r, g, b;
                if (whiteData.data[i + 3] == 0) {
                    r = rgb[0];
                    g = rgb[1];
                    b = rgb[2];
                }
                else {
                    whiteData.data[i] = rgb[0] * whiteData.data[i] / 255 * lightness;
                    whiteData.data[i + 1] = rgb[1] * whiteData.data[i + 1] / 255 * lightness;
                    whiteData.data[i + 2] = rgb[2] * whiteData.data[i + 2] / 255 * lightness;
                }
            }

            this.cxt.putImageData(whiteData, 0, 0);

            //再绘制编号(小于5像素，不绘制)
            var fontSize = width * 2 / 5;

            // if (fontRgb != undefined) 
            {
                this.cxt.font = fontSize + "px 隶书";
                this.cxt.fillStyle = 'rgb(' + fontRgb[0] + ',' + fontRgb[1] + ',' + fontRgb[2] + ')';
                this.cxt.textAlign = "center";
                this.cxt.textBaseline = "middle";
                this.cxt.fillText(seq, width / 2, height / 2);
            }
            
            let imgUrl = this.canvas.toDataURL();
            item = {
                rgb: rgb,
                imgUrl: imgUrl,
            }
        }
        callback && callback(item.imgUrl)
    }
    else {
        this.waitList.push(() => this.convert(rgb, seq, fontRgb, callback))
    }

}

//颜色转换
function colorRgb(s) {
    // 16进制颜色值的正则
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

    if (s.length == 3)
    {
        return s;
    }

    // 把颜色值变成小写
    var color = s.toLowerCase();
    if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
            var colorNew = "#";
            for (var i = 1; i < 4; i += 1) {
                colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
            }
            color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (var i = 1; i < 7; i += 2) {
            colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return colorChange;
    } else {
        return color;
    }
}